<template>
  <div class="callact-main" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" left-arrow @click-left="goPrevious">
      <template #left>
        <img class="left-nav" src="./images/c-left-arrow.png" alt="" />
      </template>
    </van-nav-bar>

    <div class="rules-bg" :style="{ 'margin-top': `-${barHeight * 1 + 46}px` }">
      <img class="callact-head" src="./images/top-bg.png" />
      <div class="callact-con">
        <div :style="{ height: `${barHeight * 1 + 46}px` }"></div>
        <div class="rule-tit1">{{ $t('lang.ActCommon.k009') }}</div>
        <!-- prettier-ignore -->
        <div class="rule-con">
          <div class="rule-tit2" style="margin-top: 0">1. {{ $rt('lang.CallMotivation.k015') }}</div>
          <div class="rule-txt">
            ·<p>{{ $rt('lang.CallMotivation.k016') }}</p>
          </div>

          <div class="rule-tit2">2. {{ $t('lang.CallMotivation.k017') }}</div>
          <div class="rule-txt">
            <template v-if="unit === 1">
              ·<p>{{ $rt('lang.CallMotivation.k038') }}</p>
            </template>
            <template v-else>
              ·<p>{{ $rt('lang.CallMotivation.k018') }}</p>
            </template>
          </div>

          <div class="rule-tit2">3. {{ $t('lang.CallMotivation.k019') }}</div>
          <div class="rule-txt">
            <template v-if="unit === 1">
              ·<p>{{ $t('lang.CallMotivation.k041') }}</p>
            </template>
            <template v-else>
              ·<p>{{ $t('lang.CallMotivation.k020') }}</p>
            </template>
          </div>
          <div class="rule-txt">
            <template v-if="unit === 1">
              ·<p>{{ $t('lang.CallMotivation.k040') }}</p>
            </template>
            <template v-else>
              ·<p>{{ $t('lang.CallMotivation.k021') }}</p>
            </template>
          </div>

          <div class="rule-tit2">4. {{ $t('lang.CallMotivation.k022') }}</div>
          <div class="rule-txt">
            ·<p>{{ $t('lang.CallMotivation.k023') }}</p>
          </div>
          <div class="rule-txt">
            ·<p>{{ $t('lang.CallMotivation.k024') }}</p>
          </div>

          <div class="rule-tit2">5. {{ $t('lang.CallMotivation.k025') }}</div>
          <div class="rule-txt">
            ·<p>{{ $t('lang.CallMotivation.k026') }}</p>
          </div>
          <div class="rule-txt">
            ·<p>{{ $rt('lang.CallMotivation.k027') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let query = this.$route.query
    return {
      unit: query.unit ? query.unit * 1 : 60
    }
  }
}
</script>

<style lang="scss" scoped>
.callact-main {
  width: 100%;
  min-height: 100vh;
  background-color: #df015d;

  .van-bar {
    z-index: 99;
    .left-nav {
      width: 32px;
      height: 32px;
    }
  }

  .rules-bg {
    width: 100%;
    .callact-head {
      width: 100%;
    }
  }

  .callact-con {
    margin-top: -486px;

    .rule-tit1 {
      color: #40000f;
      text-align: center;
      font-family: 'Anton-Regular';
      font-size: 34px;
      font-style: normal;
      font-weight: 400;
      line-height: 55px;
    }
    .rule-con {
      position: relative;
      width: 343px;
      margin: 20px auto;
      padding: 20px 16px;
      border-radius: 12px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.72) 100%);

      .rule-tit2 {
        color: #40000f;
        font-family: 'Oswald-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        margin-top: 16px;
      }
      .rule-txt {
        color: #805d65;
        font-family: 'Oswald-Regular';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 15px;

        display: flex;
        align-items: flex-start;

        margin-top: 12px;
      }
    }
  }
}
</style>
